/*
  The thin client only has basic functionality like getting the events and uuid's.
  This prevents having to include extra dependencies that are only needed for actual backend communication.
  This is used by the partner iframes.
 */

import { getCookie } from "@/lib/helpers/cookies";
import { sSessionStorage } from "@/lib/helpers/localStorage";

function getArgusEvents() {
  return sSessionStorage.getItem("argusEvents");
}

function getSessionUuid() {
  return sSessionStorage.getItem("solvariSession");
}

function getSolvariClientId() {
  return getCookie("solvariClientId", false);
}

function argusSession() {
  return {
    sessionUuid: getSessionUuid(),
    clientId: getSolvariClientId(),
  };
}

function shouldApplyArgusSession(link: string) {
  try {
    const url = new URL(link);
    return (
      (url.protocol === "http:" || url.protocol === "https:") &&
      url.hostname !== window.location.hostname
    );
  } catch (_error) {
    return false;
  }
}

function applyArgusUuidToUrl(link: string) {
  if (!shouldApplyArgusSession(link)) {
    return link;
  }

  const url = new URL(link);
  const session = argusSession();

  if (session.sessionUuid) {
    url.searchParams.set("solvariSession", session.sessionUuid);
  }
  if (session.clientId) {
    url.searchParams.set("solvariClientId", session.clientId);
  }

  return url.href;
}

export {
  applyArgusUuidToUrl,
  argusSession,
  getArgusEvents,
  getSessionUuid,
  getSolvariClientId,
  shouldApplyArgusSession,
};
